import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { ArrowLeft, LogOut } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { ProfileSettings } from "@/lib/types";

interface SettingsViewProps {
  settings: ProfileSettings;
  onBack: () => void;
  onSettingToggle: (setting: keyof ProfileSettings) => void;
  onClose: () => void;
}

export const SettingsView = ({ settings, onBack, onSettingToggle, onClose }: SettingsViewProps) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Button variant="ghost" size="icon" onClick={onBack}>
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <h3 className="font-semibold">Settings</h3>
      </div>
      <div className="space-y-4 border rounded-lg p-4">
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <div className="font-medium">Public Profile</div>
              <div className="text-sm text-muted-foreground">Allow others to view your profile</div>
            </div>
            <Switch
              checked={settings.is_public}
              onCheckedChange={() => onSettingToggle('is_public')}
            />
          </div>
          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <div className="font-medium">Anonymous Mode</div>
              <div className="text-sm text-muted-foreground">Hide your identity in posts and comments</div>
            </div>
            <Switch
              checked={settings.anonymous_mode}
              onCheckedChange={() => onSettingToggle('anonymous_mode')}
            />
          </div>
          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <div className="font-medium">Show Statistics</div>
              <div className="text-sm text-muted-foreground">Display your activity statistics</div>
            </div>
            <Switch
              checked={settings.show_statistics}
              onCheckedChange={() => onSettingToggle('show_statistics')}
            />
          </div>
        </div>
      </div>
      <Button 
        variant="destructive" 
        className="w-full justify-start"
        onClick={() => {
          supabase.auth.signOut();
          onClose();
        }}
      >
        <LogOut className="mr-2 h-4 w-4" /> Logout
      </Button>
    </div>
  );
};